export default __webpack_public_path__ + "static/media/facct22-cfactuals.610e19e8.pdf";